import MaterialAppBar from "@mui/material/AppBar";
import MuiToolbar from "@mui/material/Toolbar";
import React from "react";
import styled from "styled-components";
import Flex from "src/components/flex";
import Gutters from "src/components/gutters";
import AdadotLink from "src/components/link";
import { Button } from "@mui/material";
import Auth from "src/services/auth";
import { getBaseUrl } from "src/utils/url";
import Logo from "./logo";

const Toolbar = styled(MuiToolbar)`
    height: 68px;
`;

const LinkContainerDesktop = styled(Flex)`
    margin-left: ${({ theme }) => theme.spacing(4)};
    height: 100%;
    ${({ theme }) => theme.breakpoints.down("md")} {
        display: none;
    }
`;

const AppBar = styled(MaterialAppBar)`
    box-shadow: none;
    background-color: ${({ theme }) => theme.palette.background.default};
`;

const Offset = styled("div")(({ theme }) => theme.mixins.toolbar);

const HeaderGuest = () => {
    return (
        <>
            <AppBar position="fixed" color="transparent">
                <Gutters py={0}>
                    <Toolbar disableGutters>
                        <Flex width="100%" flex="1 0 auto" height="100%">
                            <AdadotLink variant="plain" to="/" aria-label="Adadot Homepage">
                                <Logo />
                            </AdadotLink>
                            <LinkContainerDesktop justifyContent="flex-end">
                                <Button
                                    variant="outlined"
                                    href={`${getBaseUrl()}/dashboard`}
                                    onClick={() => {
                                        localStorage.setItem(
                                            "token",
                                            JSON.stringify({
                                                id_token:
                                                    "eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCIsImtpZCI6IkVCN1dEZEZMUVVTRXhIbFdGb1hJVSJ9.eyJodHRwOi8vYWRhZG90LmNvbS9vcmdhbml6YXRpb25JZCI6ImRlbW8tb3JnIiwiaHR0cDovL2FkYWRvdC5jb20vanRpIjoiYjNjMGRjYjItMTYxYi00ZDk2LWFhZmEtNjBmZDM3MTM2MDU1IiwiaHR0cDovL2FkYWRvdC5jb20vcGxhbnMiOlt7ImlkIjoic3ViXzFMQzFYdkM3MzVXTFk5dkJlQm5zWXpOZSIsIm5hbWUiOiJUZWFtIiwidHlwZSI6InRlYW0iLCJpc0FkbWluIjpmYWxzZSwic3RhdHVzIjoiYWN0aXZlIn1dLCJodHRwOi8vYWRhZG90LmNvbS9yZXNvdXJjZV9wZXJtaXNzaW9ucyI6WyJvcmc6KjpzdXBlci1hZG1pbiIsInd1Oio6c3VwZXItYWRtaW4iXSwiaHR0cDovL2FkYWRvdC5jb20vbWVyZ2VkX2lkZW50aXR5IjoiZGVtby11c2VyIiwiaHR0cDovL2FkYWRvdC5jb20vbG9naW5fbWV0aG9kX3ZlcmlmaWVkIjp0cnVlLCJuaWNrbmFtZSI6IkRlbW8gVXNlciIsIm5hbWUiOiJEZW1vIFVzZXIiLCJwaWN0dXJlIjoiaHR0cHM6Ly9saDMuZ29vZ2xldXNlcmNvbnRlbnQuY29tL2EvQUxtNXd1MGI5bTZCYzA5Ui12NVlXdHo3RmNwSlRmMjhkbTBzckxfaUJRX1I9czk2LWMiLCJ1cGRhdGVkX2F0IjoiMjAyMy0wMS0xM1QxMToyNzo0Ny44NTFaIiwiZW1haWwiOiJkZW1vQGFkYWRvdC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiaXNzIjoiaHR0cHM6Ly9hZGFkb3QtcGxhdGZvcm0uZXUuYXV0aDAuY29tLyIsInN1YiI6ImRlbW8tdXNlciIsImF1ZCI6InpTVkh1OExHT0JoRWk5a2VNMVlyWWlpZWg5VTNHeFdJIiwiaWF0IjoxNjczNjA5MjcxLCJleHAiOjE2NzM2NDUyNzEsInNpZCI6IjNOV2lfTUY1TUtKNHVEdU9DTUFhQVZudU4wSV9JWC1FIn0.pgC0iLxb6tiHgxxJrV_NMsfpSHbHYgKaqU8ju9BQjw9yo4EcRNI60E0NHFM_KiV_k0MQDl8ryA5DYRDwI2JVTQ",
                                                access_token:
                                                    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IkVCN1dEZEZMUVVTRXhIbFdGb1hJVSJ9.eyJodHRwOi8vYWRhZG90LmNvbS9qdGkiOiJiM2MwZGNiMi0xNjFiLTRkOTYtYWFmYS02MGZkMzcxMzYwNTUiLCJpc3MiOiJodHRwczovL2FkYWRvdC1wbGF0Zm9ybS5ldS5hdXRoMC5jb20vIiwic3ViIjoiZGVtby11c2VyIiwiaWF0IjoxNjczNjA5MjcxLCJleHAiOjQxMDM1MjMwNzEsImF6cCI6InpTVkh1OExHT0JoRWk5a2VNMVlyWWlpZWg5VTNHeFdJIiwic2NvcGUiOiJvcGVuaWQgcHJvZmlsZSBlbWFpbCBvZmZsaW5lX2FjY2VzcyJ9.z-L4FkG2zoCZv8tK0Qf6jJRbxWbxN3W7lE9K8ggZNa0",
                                                expires_in: 86400,
                                            })
                                        );
                                    }}
                                    sx={{ marginRight: "12px" }}
                                >
                                    View Demo
                                </Button>
                                <Button
                                    variant="outlined"
                                    onClick={() => {
                                        Auth.redirectToLogin();
                                    }}
                                >
                                    Register Now
                                </Button>
                            </LinkContainerDesktop>
                        </Flex>
                    </Toolbar>
                </Gutters>
            </AppBar>
            <Offset />
        </>
    );
};

export default HeaderGuest;
